import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useCallback } from 'react';
import { useBiContextGetter } from './BiContext';
export function useBiAction() {
    const getBiContext = useBiContextGetter();
    return useCallback((biEvent)=>{
        var _getBiContext;
        (_getBiContext = getBiContext()) === null || _getBiContext === void 0 ? void 0 : _getBiContext.logBiAction(biEvent);
    }, [
        getBiContext
    ]);
}
export function useBiPageView() {
    const getBiContext = useBiContextGetter();
    return useCallback((biEvent)=>{
        var _getBiContext;
        (_getBiContext = getBiContext()) === null || _getBiContext === void 0 ? void 0 : _getBiContext.logBiPageView(biEvent);
    }, [
        getBiContext
    ]);
}
export function useTransaction() {
    const getBiContext = useBiContextGetter();
    return useCallback((input)=>{
        const transactionName = typeof input === 'string' ? input : input.transactionName;
        const context = getBiContext();
        if (context) {
            return context.startTransaction(_object_spread({
                transactionName
            }, typeof input === 'object' ? input : {}));
        }
        // Return no-op if no context
        return ()=>{};
    }, [
        getBiContext
    ]);
}
export function useBiProvider() {
    var _getBiContext;
    const getBiContext = useBiContextGetter();
    return (_getBiContext = getBiContext()) !== null && _getBiContext !== void 0 ? _getBiContext : {
        logBiAction: ()=>{},
        logBiPageView: ()=>{},
        logBiModalView: ()=>{},
        startTransaction: ()=>()=>{}
    };
}
